import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { INewsFeedConfigurationData, NewsLanguage, NewsStatus, NewsRssFeedType } from '@bciti/types';

@Component({
    selector: 'app-news-rss-feeds-form',
    templateUrl: './news-rss-feeds-form.component.html',
    styleUrls: ['./news-rss-feeds-form.component.scss'],
})
export class NewsRssFeedsFormComponent implements OnInit {
    @Input() newsForm: FormGroup;

    @Output() newsFormChange = new EventEmitter<INewsFeedConfigurationData>();

    @Output() submitFormEvent = new EventEmitter();

    readonly separatorKeysCodes = [ENTER, COMMA] as const;

    constructor(private fb: FormBuilder) {}

    ngOnInit(): void {}

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (value) {
            this.newsForm.get('newsCustomFieldsItem').setValue([...this.newsForm.get('newsCustomFieldsItem').value, value]);
        }

        event.input.value = '';
    }

    remove(item: string): void {
        const items = this.newsForm.get('newsCustomFieldsItem').value as string[];
        const index = items.indexOf(item);
        if (index < 0) {
            return;
        }
        items.splice(index, 1);

        this.newsForm.get('newsCustomFieldsItem').setValue(items);
    }

    get availableNewsStatus() {
        return Object.values(NewsStatus);
    }

    get availableNewsRssFeedTypes() {
        return Object.values(NewsRssFeedType);
    }

    get availableNewsLanguage() {
        return Object.values(NewsLanguage);
    }
}
